// Branding helper — fetches the public branding settings (app name, browser
// title, active brand, sign-in page) and applies them at runtime: document
// title, favicon set, apple-touch-icon and the PWA manifest all swap to the
// active brand's dynamically-served assets, so a brand flip takes effect
// immediately on any host (preview or self-hosted VPS) with no rebuild.

let cached = null;

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

// Synchronous read of the last-fetched branding (null until first load).
export function peekBranding() {
  return cached;
}

function _applyRuntimeAssets(b) {
  if (typeof document === "undefined") return;
  const v = b.icon_version || 0;
  const icon = (name) => `${API_BASE}/api/branding/icon/${name}?v=${v}`;
  document.querySelectorAll('link[rel="icon"]').forEach((el) => {
    const sizes = el.getAttribute("sizes");
    el.href = icon(sizes === "16x16" ? "favicon-16.png" : "favicon-32.png");
  });
  const shortcut = document.querySelector('link[rel="shortcut icon"]');
  if (shortcut) shortcut.href = icon("favicon.ico");
  const apple = document.querySelector('link[rel="apple-touch-icon"]');
  if (apple) apple.href = icon("apple-touch-icon.png");
  const manifest = document.querySelector('link[rel="manifest"]');
  if (manifest) manifest.href = `${API_BASE}/api/branding/manifest.webmanifest?v=${v}`;
  const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (appleTitle && b.app_name) appleTitle.setAttribute("content", b.app_name);
}

export async function loadBranding(force = false) {
  if (!force && cached) return cached;
  try {
    const res = await fetch(`${API_BASE}/api/branding`, { cache: "no-store" });
    if (!res.ok) throw new Error(`branding ${res.status}`);
    cached = await res.json();
    document.title = cached.browser_title || cached.app_name || "Elite";
    _applyRuntimeAssets(cached);
  } catch {
    cached = null;
  }
  return cached;
}
